import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["columns", "rows", "areas", "gapX", "gapY", "alignItemsX", "alignItemsY", "alignX", "alignY", "flow", "style", "className"];
import React from 'react';
import pt from 'prop-types';
import { Box, BreakpointContext, breakpointPropSwitch } from '../';
import { appendHtmlClass, extendProps, getSpaceValue, responsivePropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var Grid = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Grid, _React$Component);
  function Grid() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_CLASS = 'grid';
    return _this;
  }
  var _proto = Grid.prototype;
  _proto.getResponsiveValue = function getResponsiveValue(options) {
    return breakpointPropSwitch(options, this.context);
  };
  _proto.getTrackStyle = function getTrackStyle(track, isRow) {
    if (isRow === void 0) {
      isRow = false;
    }
    if (!track) return {};
    var value = this.getResponsiveValue(track);
    if (typeof value === 'number') value = "repeat(" + value + ", 1fr)";
    return isRow ? {
      gridTemplateRows: value
    } : {
      gridTemplateColumns: value
    };
  };
  _proto.getAreaStyle = function getAreaStyle(areas) {
    if (!areas) return {};
    var value = this.getResponsiveValue(areas);
    if (value.length <= 0) return {};
    return {
      gridTemplateAreas: value.map(function (area) {
        return "\"" + area + "\"";
      }).join(' ')
    };
  };
  _proto.getGapStyle = function getGapStyle(gap, isVertical) {
    if (isVertical === void 0) {
      isVertical = false;
    }
    if (typeof gap === 'undefined') return {};
    var value = getSpaceValue(this.getResponsiveValue(gap));
    return isVertical ? {
      gridRowGap: value
    } : {
      gridColumnGap: value
    };
  };
  _proto.getEnumStyle = function getEnumStyle(prop, name) {
    var _ref;
    if (!prop) return {};
    var value = this.getResponsiveValue(prop);
    return _ref = {}, _ref[name] = value, _ref;
  };
  _proto.getStyle = function getStyle(style, columns, rows, areas, gapX, gapY, alignItemsX, alignItemsY, alignX, alignY, flow) {
    return Object.assign(typeof style == 'object' ? style : {}, this.getTrackStyle(columns), this.getTrackStyle(rows, true), this.getAreaStyle(areas), this.getGapStyle(gapX), this.getGapStyle(gapY, true), this.getEnumStyle(alignItemsX, 'justifyItems'), this.getEnumStyle(alignItemsY, 'alignItems'), this.getEnumStyle(alignX, 'justifyContent'), this.getEnumStyle(alignY, 'alignContent'), this.getEnumStyle(flow, 'gridAutoFlow'));
  };
  _proto.render = function render() {
    var _this$props = this.props,
      columns = _this$props.columns,
      rows = _this$props.rows,
      areas = _this$props.areas,
      gapX = _this$props.gapX,
      gapY = _this$props.gapY,
      alignItemsX = _this$props.alignItemsX,
      alignItemsY = _this$props.alignItemsY,
      alignX = _this$props.alignX,
      alignY = _this$props.alignY,
      flow = _this$props.flow,
      style = _this$props.style,
      className = _this$props.className,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var gridStyle = this.getStyle(style, columns, rows, areas, gapX, gapY, alignItemsX, alignItemsY, alignX, alignY, flow);
    var gridClass = appendHtmlClass(className, this.DEFAULT_CLASS);
    return /*#__PURE__*/React.createElement(Box, Object.assign({
      style: gridStyle,
      className: gridClass
    }, rest));
  };
  return Grid;
}(React.Component);
Grid.contextType = BreakpointContext;
Object.assign(Grid, extendProps(Box, ['className', 'id', 'children', 'width', 'height', 'border', 'borderTop', 'borderBottom', 'borderLeft', 'borderRight', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'mask', 'shadow', 'corner', 'as'], {
  columns: responsivePropType.bind(this, pt.oneOfType([pt.string, pt.number])),
  rows: responsivePropType.bind(this, pt.oneOfType([pt.string, pt.number])),
  areas: responsivePropType.bind(this, pt.arrayOf(pt.string)),
  gapX: responsivePropType.bind(this, pt.number),
  gapY: responsivePropType.bind(this, pt.number),
  alignItemsX: responsivePropType.bind(this, pt.oneOf(['start', 'end', 'center', 'stretch'])),
  alignItemsY: responsivePropType.bind(this, pt.oneOf(['start', 'end', 'center', 'stretch'])),
  alignX: responsivePropType.bind(this, pt.oneOf(['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'])),
  alignY: responsivePropType.bind(this, pt.oneOf(['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'])),
  flow: responsivePropType.bind(this, pt.oneOf(['row', 'column', 'row dense', 'column dense']))
}, {
  columns: getConfig('GRID_DEFAULT_COLUMNS')
}));
export default Grid;